import React, { useEffect, useState } from 'react';
import {
  Box,
  Button,
  Typography,
  IconButton,
  Stack,
  ListItem,
  ListItemText,
  List,
  Modal,
  CircularProgress,
  Snackbar,
  Alert
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import AddDocumentModal from './AddDocumentModal';
import { api } from 'src/Api';
import { Link } from 'react-router-dom';
import { LoadingButton } from '@mui/lab';

export default function ListDocument({ docid, onClose }) {
  const token = localStorage.getItem('token');
  const [file, setFile] = useState([]);
  const [openmodal, setOpenModal] = useState(false);
  const [error, seterror] = useState('');
  const [loading, setloading] = useState(false);
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [selectedId, setSelectedId] = useState('');

  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState('success');

  const handleRemoveFile = (id) => {
    setSelectedId(id);
    handleDelete(id);
  };

  const handleDelete = (file_id) => {
    setDeleteLoading(true);
    const myHeaders = new Headers();
    myHeaders.append('Authorization', `Bearer ${token}`);

    const formData = new FormData();
    docid && formData.append('customer_service_id', docid);
    file_id && formData.append('file_id', file_id);

    fetch(api.delete_service_document, {
      headers: myHeaders,
      body: formData,
      method: 'POST'
    })
      .then((response) => response.json())
      .then((result) => {
        if (result.success) {
          setSnackbarOpen(true);
          setSnackbarMessage(result.message);
          setSnackbarSeverity('success');
          handleListDoc();
          setDeleteLoading(false);
        } else {
          setSnackbarOpen(true);
          setSnackbarMessage(result.message);
          setSnackbarSeverity('error');
          setTimeout(() => {
            handleSnackbarClose();
          }, 2000);
          setDeleteLoading(false);
        }
      })
      .catch((error) => {
        setDeleteLoading(false);
        console.log('Fetch error:', error);
      });
  };

  const closeModal = () => setOpenModal(false);

  useEffect(() => {
    handleListDoc();
  }, []);

  const handleListDoc = () => {
    setFile([]);
    setloading(true);
    const myHeaders = new Headers();
    myHeaders.append('Authorization', `Bearer ${token}`);

    const params = new URLSearchParams();
    params.append('customer_service_id', docid);

    const url = `${api.get_service_document}?${params.toString()}`;

    const requestOptions = {
      headers: myHeaders,
      method: 'GET',
      redirect: 'follow'
    };

    fetch(url, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        if (result.success) {
          setFile(result?.data);
        } else {
          console.log('error doclist', result.message);
          seterror(result.message);
        }
      })
      .catch((error) => console.log('error', error))
      .finally(() => {
        setloading(false);
      });
  };

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  return (
    <Box>
      <Stack
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          flexDirection: 'row'
        }}
      >
        <Typography variant="h6" color={'#f90001'}>
          Document
        </Typography>
        <Button
          variant="contained"
          sx={{
            fontSize: 12
          }}
          onClick={() => {
            setOpenModal(true);
          }}
        >
          Add Document
        </Button>
      </Stack>

      <Modal open={openmodal} onClose={closeModal}>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            minHeight: '100vh'
          }}
        >
          <Box
            style={{
              width: '40%',
              backgroundColor: '#ffffff',
              boxShadow: 24,
              overflow: 'auto',
              padding: 10,
              borderRadius: 5,
              border: '2px solid #f90001'
            }}
          >
            <Typography variant="h6" color={'#f90001'}>
              Upload A Document
            </Typography>
            <AddDocumentModal
              onClose={closeModal}
              adddocid={docid}
              getdata={() => {
                setTimeout(() => {
                  closeModal();
                }, 1000);
                handleListDoc();
              }}
            />
          </Box>
        </Box>
      </Modal>

      <Box>
        {file && !loading && (
          <List>
            {file.map((doc, index) => (
              <>
                <Box>
                  <ListItem
                    style={{
                      height: 70,
                      backgroundColor: 'rgba(0,0,0,0.05)',
                      borderRadius: 5,
                      marginTop: 10
                    }}
                    key={index}
                    secondaryAction={
                      <Box
                        sx={{
                          display: 'flex',
                          flexDirection: 'column',
                          alignItems: 'flex-end'
                        }}
                      >
                        <LoadingButton
                          loading={deleteLoading && doc?.id == selectedId ? true : false}
                          style={{ width: 0, height: 30 }}
                          edge="end"
                          aria-label="delete"
                          onClick={() => handleRemoveFile(doc?.id)}
                        >
                          {!deleteLoading && doc?.id !== selectedId && (
                            <DeleteIcon style={{ color: '#f90001', fontSize: 18 }} />
                          )}
                        </LoadingButton>
                        <p style={{ fontSize: 11, color: 'black' }}>{doc?.created_at}</p>
                      </Box>
                    }
                  >
                    <div>
                      <Link to={doc?.url} target="blank" style={{ fontSize: 13, color: 'black' }}>
                        {doc?.file_name}
                      </Link>
                      <p style={{ fontSize: 13, fontWeight: '500', color: '#f90001' }}>
                        Uploaded by: {doc?.uploaded_by}
                      </p>
                    </div>
                  </ListItem>
                </Box>
              </>
            ))}
          </List>
        )}
        {/* loader */}
        {loading && (
          <Box
            sx={{
              height: '40vh',
              flex: 1,
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center'
            }}
          >
            <CircularProgress />
          </Box>
        )}

        {file?.length == 0 && !loading && (
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              height: '40vh'
            }}
          >
            <Typography color={'#ccc'}>{error}</Typography>
          </Box>
        )}

        <Snackbar open={snackbarOpen} autoHideDuration={4000} onClose={handleSnackbarClose}>
          <Alert onClose={handleSnackbarClose} severity={snackbarSeverity}>
            {snackbarMessage}
          </Alert>
        </Snackbar>
      </Box>
      <Stack
        sx={{
          display: 'flex',
          justifyContent: 'flex-end',
          alignItems: 'flex-end'
          // flexDirection: 'row'
        }}
      >
        <Button
          variant="contained"
          sx={{
            fontSize: 12
            // width: 100
          }}
          onClick={onClose}
        >
          Close
        </Button>
      </Stack>
    </Box>
  );
}
